var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2753 2.46436C5.96095 2.46436 2.46436 5.96095 2.46436 10.2753C2.46436 14.5897 5.96095 18.0863 10.2753 18.0863C14.5888 18.0863 18.0863 14.5896 18.0863 10.2753C18.0863 5.961 14.5888 2.46436 10.2753 2.46436ZM0.964355 10.2753C0.964355 5.13252 5.13252 0.964355 10.2753 0.964355C15.4171 0.964355 19.5863 5.13247 19.5863 10.2753C19.5863 15.4181 15.4171 19.5863 10.2753 19.5863C5.13252 19.5863 0.964355 15.4181 0.964355 10.2753Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8987 18.2378C18.5336 18.2378 18.2373 18.5347 18.2373 18.8983C18.2373 19.2637 18.5336 19.5597 18.8987 19.5597C19.2632 19.5597 19.5592 19.2644 19.5592 18.8983C19.5592 18.5341 19.2632 18.2378 18.8987 18.2378ZM16.7373 18.8983C16.7373 17.7056 17.7058 16.7378 18.8987 16.7378C20.0923 16.7378 21.0592 17.7063 21.0592 18.8983C21.0592 20.0922 20.0923 21.0597 18.8987 21.0597C17.7058 21.0597 16.7373 20.0928 16.7373 18.8983Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.a31e5ed9a490cb97552cf137499a78e1.svg";
export { ForwardRef as ReactComponent };